

const About = () => {
    return (
        <div className="max-w-4xl mx-auto p-6 text-gray-800">
          <h1 className="text-3xl font-bold mb-4">About Plog.dev</h1>

          <p className="mb-4">
            <strong>Plog.dev is a platform for documenting your journey — wherever you're headed.</strong>
          </p>

          <p className="mb-4">
            Whether you're a technician mastering your trade, a nurse starting your career, a student learning to code, or a chef refining your recipes — <strong>Plog.dev is built for you.</strong> It's a space where anyone can write, reflect, and grow through personal and professional blogging.
          </p>

          <p className="mb-4">
            We created Plog.dev to give people from all backgrounds a simple, welcoming place to share progress, lessons learned, and milestones along the way. From daily logs and how-to guides to career reflections and goal tracking — <strong>every voice matters here.</strong>
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">Why Document Your Journey?</h2>
          <ul className="list-disc list-inside space-y-2 mb-6">
            <li>📖 Turn everyday experiences into a record of growth</li>
            <li>🧠 Reflect on your progress and challenges</li>
            <li>💡 Inspire others on similar paths</li>
            <li>🗣️ Build your voice and confidence through writing</li>
            <li>🌍 Connect with a diverse community of learners, workers, and creators</li>
          </ul>

          <p className="mb-4">
            You don't need to be a professional writer. You just need a story to tell — and we all have one. Plog.dev makes it easy to start and keep going.
          </p>

          <p className="text-gray-600">
            So whether you're learning to code, starting a side hustle, shifting careers, or just trying something new — <strong>start documenting your journey today</strong> on Plog.dev.
          </p>
        </div>
    )
};

export default About;
